import { render, staticRenderFns } from "./ListWinesCopy.vue?vue&type=template&id=95cae772&"
import script from "./ListWinesCopy.vue?vue&type=script&lang=js&"
export * from "./ListWinesCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports